import StoreSettingsPage from './detail/StoreSettingsPage';
import ShippingMethodsTab from './detail/ShippingMethodsTab';

export default function StoreShippingMethods() {
	return (
		<StoreSettingsPage title='Store - Shipping Methods'>
			{(store) => <ShippingMethodsTab storeId={store.storeId} />}
		</StoreSettingsPage>
	);
}
